import appApi from '../../../../api/app-api';
import { toast } from 'react-toastify';

export const fetchProfessorLecturesOperation = async (
  professorId: number,
  filters: {
    offset: number;
    limit: number;
    startDate: Date | null;
    endDate: Date | null;
  },
  setLoading: (loading: boolean) => void,
  setLectures: (rows: any[]) => void,
) => {
  try {
    setLoading(true);
    const res = await appApi.getProfessorLectures(professorId, filters);
    const body = res.data.body as any;
    const rows = Array.isArray(body) ? body : (body?.data ?? []);
    // Non-breaking: keep original fields, add normalized date fields for safer rendering
    const normalized = rows.map((r: any) => {
      const start =
        r?.startTime != null ? new Date(r.startTime as any) : undefined;
      const end = r?.endTime != null ? new Date(r.endTime as any) : undefined;
      const startValid = start instanceof Date && !isNaN(start.getTime());
      const endValid = end instanceof Date && !isNaN(end.getTime());
      return {
        ...r,
        _startTimeDate: startValid ? start : undefined,
        _endTimeDate: endValid ? end : undefined,
      };
    });
    setLectures(normalized);
  } catch (e) {
    console.error('fetchProfessorLecturesOperation failed', e);
    toast.error('טעינת המפגשים נכשלה, נסה שוב בעוד מספר רגעים');
  } finally {
    setLoading(false);
  }
};
